import React, { Fragment } from "react";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import LocationDetails from "./LocationDetails";
import DevicesOnLocation from "./DevicesOnLocation";
import NotesDetails from "../Notes/Notes";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

class LocationDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locationDetails: null,
      redirect: null,
      tabValue: 0,
      locationID: props.location,
    };
  }

  handleChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  render() {
    let locationDetailsContainer = (
      <LocationDetails locationId={this.props.location} />
    );
    let devicesOnLocationContainer = (
      <DevicesOnLocation locationId={this.props.location} />
    );
    let NotesContainer;
    try {
      NotesContainer = (
        <NotesDetails Id={this.props.location} model_type="Location" />
      );
    } catch (error) {
      console.log("error loading notes");
    }

    return (
      <Fragment>
        <h1>{this.props.location ? this.props.location : "Hold on man"}</h1>

        <AppBar position="static" style={{ background: "#2E3B55" }}>
          <Tabs
            value={this.state.tabValue}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="auto"
            indicatorColor="secondary"
          >
            <Tab
              label="Location Details"
              disabled={locationDetailsContainer === null}
            />
            <Tab
              label="Devices on Location"
              disabled={devicesOnLocationContainer === null}
            />
            <Tab label="Notes" />
          </Tabs>
        </AppBar>

        <TabPanel value={this.state.tabValue} index={0}>
          <Grid>{locationDetailsContainer}</Grid>
        </TabPanel>
        <TabPanel value={this.state.tabValue} index={1}>
          <Grid>{devicesOnLocationContainer}</Grid>
        </TabPanel>
        <TabPanel value={this.state.tabValue} index={2}>
          <Grid item>
            <h2>Notes</h2>
            {NotesContainer}
          </Grid>
        </TabPanel>
      </Fragment>
    );
  }
}

export default LocationDashboard;
